module.exports = __webpack_public_path__ + "2788c4e528fd9f517c904a99bca973f2.svg";